<template>
  <div>
    <MainMenu :withNav="false" />
    <router-view/>
  </div>
</template>

<script>
  import MainMenu from "../components/app/MainMenu";

  export default {
      components: {MainMenu},
    };
</script>

<style scoped></style>